import React, { useEffect, useState } from "react";
import { IMaskInput } from "react-imask";
import formatarData from "../../../Utils/formatarData";

function toDisplay(value) {
  if (!value) return "";
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const formatada = formatarData(value);
    return formatada === "Data inválida" ? "" : formatada;
  }
  const formatada = formatarData(value);
  return formatada === "Data inválida" ? "" : formatada;
}

function toIso(display) {
  if (!display || !/^\d{2}\/\d{2}\/\d{4}$/.test(display)) return "";
  const [dia, mes, ano] = display.split("/");
  return `${ano}-${mes}-${dia}`;
}

function isDataValida(display) {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(display)) return false;
  const [dia, mes, ano] = display.split("/").map(Number);
  const date = new Date(ano, mes - 1, dia);
  return (
    date.getFullYear() === ano &&
    date.getMonth() === mes - 1 &&
    date.getDate() === dia
  );
}

/**
 * Input de data com máscara dd/MM/yyyy.
 * value/onChange usam yyyy-MM-dd (ISO) para integração com o backend.
 * Props: value, onChange, placeholder, id, className, disabled, name, required.
 */
export default function Data({
  value,
  onChange,
  placeholder = "dd/mm/aaaa",
  id,
  className = "form-control",
  disabled,
  name,
  required = false,
  title,
}) {
  const [display, setDisplay] = useState(() => toDisplay(value));

  useEffect(() => {
    setDisplay(toDisplay(value));
  }, [value]);

  const handleAccept = (val) => {
    setDisplay(val);

    if (!val) {
      if (onChange) onChange("");
      return;
    }

    if (val.length === 10 && isDataValida(val)) {
      if (onChange) onChange(toIso(val));
    }
  };

  return (
    <IMaskInput
      mask="00/00/0000"
      value={display}
      onAccept={handleAccept}
      unmask={false}
      inputMode="numeric"
      placeholder={placeholder}
      className={className}
      id={id}
      name={name}
      disabled={disabled}
      required={required}
      title={title}
    />
  );
}
